import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import FieldsYieldsReport from '../../presentation/reports/FieldsYieldsReport/FieldsYieldsReport';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import { MainContainer } from '../../styles/styles';
import SecurityTrim from '../../services/auth/SecurityTrim';
import { myFieldsAndYieldsRequiredRoleDefinitions } from '../../services/auth/predefinedPermissions/predefinedRoleDefinitionsGroups';
import FieldNominationBanner from '../../presentation/features/fdtm_banner/FieldNominationBanner';
import { fieldNominationPath } from '../../routes';
import {
  LeftPlaceholder,
  MainContentWrapper,
  RightWidgetContainer,
} from './styles';
import GeneralDocumentsComponent from '../../presentation/features/general_documents/GeneralDocumentsComponent/GeneralDocumentsComponent';
import { CropConnectRoleDefinitions } from '../../services/cropConnectApiClient';

const MyFieldsYields = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  const handleBannerClick = () => {
    navigate(fieldNominationPath);
  };
  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.fieldsAndYields_report_title)} />
      <MainContentWrapper>
        <LeftPlaceholder>
          <SecurityTrim
            requiredBusinessPartnerRoles={
              myFieldsAndYieldsRequiredRoleDefinitions
            }
            fallback={
              <div>{t(TranslationKeys.common_report_not_released)}</div>
            }
          >
            <FieldsYieldsReport />
          </SecurityTrim>
        </LeftPlaceholder>
        <RightWidgetContainer>
          <SecurityTrim
            requiredGlobalRoles={[CropConnectRoleDefinitions.Internal_Employee]}
          >
            <FieldNominationBanner onClick={handleBannerClick} />
          </SecurityTrim>
          <GeneralDocumentsComponent parent="my-fields-yields" />
        </RightWidgetContainer>
      </MainContentWrapper>
    </MainContainer>
  );
};

export default MyFieldsYields;
